<template>
  <div class="fee-template">
    <headBox title="服务费模板"></headBox>
    <div class="content">
      <el-form class="select-form-new follow" :inline="true">
        <el-form-item label="模板名称">
          <el-input v-model="searchParams.name" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="[1, 2].includes(userinfo.userLevel) && [1, 2].includes(userinfo.level * 1)" label="使用团队">
          <el-select clearable v-model="searchParams.subMechanId" placeholder="请选择" filterable>
            <el-option v-for="(bean, i) in userList" :key="i" :label="bean.shortName" :value="bean.id"></el-option>
          </el-select>
        </el-form-item>
        <div class="btn-box">
          <el-button class="org-btn small" @click="searchAjax()">查询</el-button>
          <el-button class="org-btn small" @click="$refs.editForm.open({})">新增</el-button>
        </div>
      </el-form>

      <el-table border :data="tableData" style="width: 100%" class="list-table" tooltip-effect="dark" v-loading="listLoading">
        <el-table-column property="productName" min-width="200" label="模板名称/ID">
          <div slot-scope="scope">
            <tooltip :txt-info="scope.row.name"></tooltip>
            <div class="info-text">{{ scope.row.code }}</div>
          </div>
        </el-table-column>
        <el-table-column property="remark" min-width="200" label="备注">
          <template slot-scope="scope">
            <tooltip :txt-info="scope.row.remark"></tooltip>
          </template>
        </el-table-column>
        <el-table-column label="使用的团队/业务员" width="140">
          <template slot-scope="scope">
            <span class="link-text" @click="goTemplateUserList(scope.row)">{{ scope.row.userNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="模板内产品" width="100">
          <template slot-scope="scope">
            <span class="link-text" @click="goDetail(scope.row)">{{ scope.row.productNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属组织" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.mechanName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务费类型" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.type == 2 ? '业务员' : '团队' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime | timeStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button-group class="line-btn-box">
              <el-button type="text" size="small" @click="$refs.editForm.open(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="coryItem(scope.row)">复制</el-button>
              <el-button type="text" size="small" @click="del(scope.row)" v-if="scope.row.isDel == 1">删除</el-button>
              <el-tooltip class="item" effect="dark" content="此费率模板正在使用中，无法删除" placement="top" v-else>
                <el-button type="text" size="small" class="disabled">删除</el-button>
              </el-tooltip>
              <el-button type="text" size="small" @click="goDetail(scope.row)">查看费率表</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page"
        background
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        :layout="$tools.pageLayout"
        :total="total"
        @size-change="
          pageNum = 1;
          pageSize = $event;
          getList();
        "
        @current-change="getList"
        info-text
      ></el-pagination>
    </div>
    <!-- 新增、编辑、复制表单 -->
    <editForm ref="editForm" @reload="searchAjax()"></editForm>
    <!-- 模板使用团队弹窗 -->
    <templateUserList ref="templateUserList" @reload="searchAjax()"></templateUserList>
  </div>
</template>
<script>
import headBox from "@/components/head.vue";
import editForm from "./components/feeTemplate/editForm";
import templateUserList from "./components/feeTemplate/templateUserList";
import tooltip from "@/components/tooltip";
import { pageTool } from "@/api/mixins";
export default {
  mixins: [pageTool],
  components: {
    templateUserList,
    editForm,
    tooltip,
    headBox,
  },
  data: () => ({
    tableData: [],
    userinfo: {},
    userList: [],//二级团队列表
    searchParams: {
    },
  }),
  activated() {
    this.getList();
  },
  mounted() {
    this.initListAjax("/master/commissonTemplate/queryList");
    const data = this.$tools.getLocal('userinfo');
    this.userinfo = this.$tools.getLocal('userinfo');
    if (data.userLevel == 1 || (data.level == 2 && data.userLevel == 2)) {
      this.getUserList();
    }
  },
  methods: {
    getUserList() {
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: {
          includeFirst: '1'
        },
      }).then(res => {
        this.userList = res.data
      })
    },
    goTemplateUserList(item) {
      this.$http({
        url: "/master/commissonTemplate/queryDetail",
        type: "put",
        params: { id: item.id }
      }).then((res) => {
        this.$refs.templateUserList.open({ ...res.data, type: item.type, mechanId: item.mechanId })
      });
    },
    goDetail(item) {
      this.$router.push({
        path: "/orgManage/feeTemplateDetail",
        query: {
          id: item.id,
          mechanId: item.mechanId,
          mechanName: item.mechanName,
          type: item.type
        }
      })
    },
    coryItem(item) {
      this.$confirm('确认复制此模板？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // customClass: "new-confirm",
      }).then(() => {
        let params = {
          ...item,
          name: item.name + "（1）",
        }
        this.$http({
          url: '/master/commissonTemplate/copyTemplate',
          type: 'POST',
          params: params
        }).then(res => {
          this.$message.success("操作成功");
          this.searchAjax();
        })
      })
    },
    del(item) {
      this.$confirm('确定删除模板?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: "new-confirm",
      }).then(() => {
        this.$http({
          url: '/master/commissonTemplate/delete',
          type: 'DELETE',
          params: {
            id: item.id,
          },
        }).then(res => {
          this.$message.success("模板删除成功");
          this.searchAjax();
        })
      })
    },
    setListParams(params) {
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/components/topSearchForm';
.fee-template {
  .content {
    padding: 20px;
    background: #fff;
    .list-table {
      .info-text {
        font-size: 12px;
        color: #a8adb7;
      }
      .link-text {
        cursor: pointer;
        color: $baseColor;
        text-decoration: underline;
      }
    }
  }
}
</style>

